import axios from '@/resources/libs/axios'

export default {
	//Documents

	updateRecordGeneralData(data) {
		return axios.post(`/gei/children-installation/documents/${data.context}/edit`,  data)
	},
	createRecordGeneralData(data) {
		return axios.post(`/gei/children-installation/documents/${data.context}/create`,  data)
	},
	getDocumentsListByRoute(id, data) {
		return axios.get(`/gei/children-installation/documents/${data.context}/get-documents-by-route/${id}`)
	},
	uploadDocuments(id, data) {
		return axios.post(`/gei/children-installation/documents/${data.context}/upload-documents/${id}`, data)
	},
	deleteRecord(id, data) {
		return axios.delete(`/gei/children-installation/documents/${data.context}/delete/${id}`)
	},
	deleteDocument(data) {
		return axios.delete(`/gei/children-installation/documents/${data.context}/delete-document`, {params: data.path})
	},
	deleteAllDocuments(data) {
		return axios.delete(`/gei/children-installation/documents/${data.context}/delete-all-documents`, {params: data})
	},
}